"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Root = ({
  id,
  appUrl,
  attributes = {},
  config
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
  id: id,
  "data-app-url": appUrl,
  "data-config": config,
  ...attributes
});
exports.Root = Root;
